















































































































































































































































































































































































































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";
import BaseInputEasy from "@/app/shared/components/base/BaseInputEasy.vue";
import BaseInputEasySlider from "@/app/shared/components/base/BaseInputEasySlider.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";
import BaseAnimation from "@/app/shared/components/base/BaseAnimation.vue";
import BaseColorpicker from "@/app/shared/components/base/BaseColorpicker.vue";
import BaseInputCircleColor from "@/app/shared/components/base/BaseInputCircleColor.vue";
import BaseToggleSwitch from "@/app/shared/components/base/BaseToggleSwitch.vue";
import { VPopover, VClosePopover } from "v-tooltip";

export default {
  name: "EndCardLayersSettings",
  components: {
    BaseSimpleSlider,
    BaseButton,
    BaseInputEasy,
    BaseInputEasySlider,
    BaseInput,
    BaseAnimation,
    BaseColorpicker,
    BaseInputCircleColor,
    BaseToggleSwitch,
    VPopover,
  },
  directives: {
    "close-popover": VClosePopover,
  },
  data: function () {
    return {
      hoverSizeSelect: "",
    };
  },
  props: {
    layer: {
      type: Object,
    },
    group: {
      type: Object,
      default: null,
    },
    block: {
      type: Object,
    },
    endCard: {
      type: Object,
    },
    hoverBlock: {
      type: String,
      default: "",
    }
  },
  computed: {},
  methods: {
    updateAnimationPackshot(endCard) {
      $eventsBus.$emit("updateAnimationPackshot", endCard);
    },
    isHoverSizeSelect(blockId, layerId) {
      return this.hoverSizeSelect === blockId + layerId;
    },
    onMouseOverSizeSelect(blockId, layerId) {
      this.hoverSizeSelect = blockId + layerId;
    },
    onMouseLeaveSizeSelect() {
      this.hoverSizeSelect = "";
    },
    getSize(min, max, defaultValue) {
      return [
        Math.round((defaultValue - min) / 3),
        Math.round(((defaultValue - min) / 3) * 2),
        defaultValue,
        Math.round((max - defaultValue) / 3 + defaultValue),
        Math.round(((max - defaultValue) / 3) * 2 + defaultValue),
        max,
      ];
    },
    changeInscribeTextInWidthAnimation(val, endCard, layer, block) {
      endCard.updateInscribeTextInWidthAnimation(val, layer);

      this.updateAnimationPackshot(endCard);

      this.$emit("changeCheckedItems", {
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.updateInscribeTextInWidthAnimation(val, layer);
        },
      });

      // Обновление названия оверлея
      // При добавлении других возможных текстов (Например, не Centr, а Left, Right) Вынести в отдельную функцию
      if (layer.text?.isTitle) {
        block.name = endCard.getAnimationPropAtPath(layer.text.path);

        this.$emit("changeCheckedItems", {
          callbackChangeAnimationCheckedItems: (twinEndCard) => {
            const twinBlock = twinEndCard.packshot.model.blocks.find(
              (b) => b.id === block.id
            );
            twinBlock.name = twinEndCard.getAnimationPropAtPath(
              layer.text.path
            );
          },
        });
      }
    },

    changeSizeTextCenterAnimation(val, endCard, layer) {
      endCard.updateSizeTextCenterAnimation(val, layer);

      this.updateAnimationPackshot(endCard);

      this.$emit("changeCheckedItems", {
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.updateSizeTextCenterAnimation(val, layer);
        },
      });
    },

    changeSizeUpTextCenterAnimation(endCard, layer, step) {
      endCard.updateSizeUpTextCenterAnimation(layer, step);

      this.updateAnimationPackshot(endCard);

      this.$emit("changeCheckedItems", {
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.updateSizeUpTextCenterAnimation(layer, step);
        },
      });
    },
    changeSizeDownTextCenterAnimation(endCard, layer, step) {
      endCard.updateSizeDownTextCenterAnimation(layer, step);

      this.updateAnimationPackshot(endCard);

      this.$emit("changeCheckedItems", {
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.updateSizeDownTextCenterAnimation(layer, step);
        },
      });
    },

    changeBorderRadiusAnimation(val, endCard, layer) {
      endCard.updateBorderRadiusAnimation(val, layer);

      this.updateAnimationPackshot(endCard);

      this.$emit("changeCheckedItems", {
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.updateBorderRadiusAnimation(val, layer);
        },
      });
    },

    changeLineWidthAnimation(val, endCard, layer) {
      endCard.updateLineWidthAnimation(val, layer);

      this.updateAnimationPackshot(endCard);

      this.$emit("changeCheckedItems", {
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.updateLineWidthAnimation(val, layer);
        },
      });
    },

    changeBlurAnimation(val, endCard, layer) {
      endCard.updateBlurAnimation(val, layer);

      this.updateAnimationPackshot(endCard);

      this.$emit("changeCheckedItems", {
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.updateBlurAnimation(val, layer);
        },
      });
    },
    changeColorAnimation(val, endCard, layer) {
      endCard.updateColorAnimation(val, layer);

      this.updateAnimationPackshot(endCard);

      this.$emit("changeCheckedItems", {
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.updateColorAnimation(val, layer);
        },
      });
    },
    changeColorGradientAnimation(val, endCard, layer) {
      endCard.updateColorGradientAnimation(val, layer);

      this.updateAnimationPackshot(endCard);

      this.$emit("changeCheckedItems", {
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.updateColorGradientAnimation(val, layer);
        },
      });
    },
    changeOpacityAnimation(val, endCard, layer) {
      endCard.updateOpacityAnimation(val, layer);

      this.updateAnimationPackshot(endCard);

      this.$emit("changeCheckedItems", {
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.updateOpacityAnimation(val, layer);
        },
      });
    },

    saveModifiedValues(val, key, layer, group, block, endCard) {
      endCard.saveModifiedValues(val, key, layer, group, block);

      this.$emit("changeCheckedItems", {
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.saveModifiedValues(val, key, layer, group, block);
        },
      });
    },
    switchLayer(endCard, layer, group, block) {
      if (
        layer.hasOwnProperty("opacity") &&
        layer.hasOwnProperty("isVisible")
      ) {
        if (layer.isVisible) {
          layer.tempValue = endCard.getAnimationPropAtPath(layer.opacity.path);
          layer.isVisible = false;
          this.changeOpacityAnimation(0, endCard, layer);
        } else {
          layer.isVisible = true;
          this.changeOpacityAnimation(layer.tempValue, endCard, layer);
        }

        this.$emit("changeCheckedItems", {
          callbackChangeAnimationCheckedItems: (twinEndCard) => {
            let twinLayer = null;
            const twinBlock = twinEndCard.packshot.model.blocks.find(
              (b) => b.id === block.id
            );

            if (group !== null) {
              const twinGroup = twinBlock.groups.find((g) => g.id === group.id);

              twinLayer = twinGroup.layers.find((l) => l.id === layer.id);
            } else {
              twinLayer = twinBlock.layers.find((l) => l.id === layer.id);
            }

            twinLayer.tempValue = twinEndCard.getAnimationPropAtPath(
              twinLayer.opacity.path
            );
            twinLayer.isVisible = layer.isVisible;
            twinLayer.isVisible
              ? twinEndCard.updateOpacityAnimation(twinLayer.tempValue, layer)
              : twinEndCard.updateOpacityAnimation(0, layer);
          },
        });

        this.saveModifiedValues(
          layer.isVisible,
          "isVisible",
          layer,
          group,
          block,
          endCard
        );
        this.saveModifiedValues(
          layer.tempValue,
          "tempValue",
          layer,
          group,
          block,
          endCard
        );
        this.saveModifiedValues(
          endCard.getAnimationPropAtPath(layer.opacity.path),
          "opacity",
          layer,
          group,
          block,
          endCard
        );
      }
    },
    replacePackshotLogoImage(layer, group, block, endCard) {
      const imgSrc = endCard.getAnimationPropAtPath(layer.image.path);
      const imgW = endCard.getAnimationPropAtPath(layer.w.path);
      const imgH = endCard.getAnimationPropAtPath(layer.h.path);
      this.$store.commit("showEndCardCropImageWindow", true);

      const saveChangesCallback = (croppedBase64Image) => {
        this.endCard.updateLogoImageAnimation(croppedBase64Image, layer);
        this.saveModifiedValues(
          croppedBase64Image,
          "image",
          layer,
          group,
          block,
          this.endCard
        );
        this.$emit("changeCheckedItems", {
          callbackChangeAnimationCheckedItems: (twinEndCard) => {
            twinEndCard.updateLogoImageAnimation(croppedBase64Image, layer);
          },
        });
      };

      setTimeout(() => {
        $eventsBus.$emit(
          "cropPackshotLogoImage",
          imgSrc,
          imgW / imgH,
          saveChangesCallback.bind(this)
        );
      }, 10);
    },
  },
};
